import type { DateRangeValue } from './DateRangeFilter';
import { FacilityHierarchyFilterValue } from './FacilityHierarchyFilter';

export const paymentReportsInitialDateRange: DateRangeValue = {
	dateBasis: 'transactionDate',
	transactionStartDate: null,
	transactionEndDate: null,
	applicationStartDate: null,
	applicationEndDate: null,
	includeSecondaryDateRange: false,
};

export const paymentReportsInitialFacilityHierarchy: FacilityHierarchyFilterValue = {
	areas: [],
	branches: [],
	districts: [],
	facilities: [],
};
